<template>
	<div class="small-box-container">
		<div class="small-box-image">
			<a href="#" @click.prevent="goToStory(story)">
				<img v-if="story.urlToImage" v-lazy="story.urlToImage" alt="Story image" />
				<div v-else class="story-name-container content">
					<h2 class="story-name">{{(story.source) ? story.source.name : 'SourceName'}}</h2>
				</div>
			</a>
		</div>
		<div class="small-box-title">
			<h1>
				<a
					href="#"
					@click.prevent="goToStory(story)"
				>{{stringLength ? truncate(story.title) : story.title}}</a>
			</h1>
			<div class="small-box-footer">
				<div class="date-div">
					<p class="story-author">{{story.author | formatAuthor}}</p>
					<p>{{story.publishedAt | formatDate}}</p>
				</div>
				<div class="button-div">
					<story-controls :story="story" class="story-controls"></story-controls>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import StoryControls from "../../story/StoryControls.vue";
import truncate from "truncate";
import { storyMixin } from "../../../mixins/storyMixin";

export default {
	mixins: [storyMixin],
	props: {
		story: {
			type: Object
		}
	},
	components: {
		StoryControls
	},
	computed: {
		stringLength() {
			return this.story.title.length > 40;
		}
	},
	methods: {
		truncate(text) {
			return truncate(text, 70);
		}
	}
};
</script>

<style lang="css" src="../../../styles/appStyles.css"></style>
<style scoped>
.small-box-container {
	display: flex;
	width: 100%;
	padding: 10px;
	border-radius: 10px;
	background-color: #171717;
	transition: all 0.3s ease-in-out;
	/* box-shadow: 0px 6px 27px -4px #171717; */
}

.activity-item .small-box-container {
	border-radius: 0px;
	border-bottom: 1px solid #101010;
	padding: 15px 20px;
}

.small-box-image {
	width: 30%;
	overflow: hidden;
	height: 100px;
	border-radius: 12px;
}

.small-box-image img {
	height: 100px;
	object-fit: cover;
	border-radius: 12px;
	width: 100%;
}

.small-box-title {
	width: 70%;
	padding-left: 20px;
	display: grid;
	align-items: center;
}

.small-box-title h1 {
	line-height: 1.1;
}

.small-box-title h1 a {
	color: #fff;
	font-size: 13px;
	/* font-family: 'Archivo Black', sans-serif; */
	/* font-family: 'Paytone One', sans-serif; */
	font-weight: normal;
	transition: all 0.2s ease-in-out;
}

.small-box-title h1:hover > a {
	color: #51c715;
}

.small-box-footer {
	display: flex;
	width: 100%;
	justify-content: space-between;
	/* padding-top: 10px; */
}

.small-box-footer p {
	font-size: 10px;
	font-weight: bold;
	color: #b7b7b7;
}

.story-author {
	color: #b00931 !important;
}

.story-controls {
	flex-direction: row !important;
	padding: 0px !important;
	justify-content: flex-end !important;
	margin-right: 0px !important;
	background-color: inherit !important;
}

@media only screen and (max-width: 768px) {
	.card-action-link ion-icon {
		font-size: 20px;
	}
}

@media only screen and (max-width: 540px) {
	.small-box-container {
		padding: 0px;
		background-color: inherit;
		margin-bottom: 10px;
		box-shadow: none;
		border-radius: 0px;
		padding-bottom: 20px;
		border-bottom: 1px solid #111;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/news/sections/SmallBoxStory.vue